
export default {
	name: 'ChatPreload',
	data () {
		return {
			
		}
	},
	computed: {

	},
	mounted() {

	},
	methods: {

	},
}
